import React from 'react';
import Markdown from 'markdown-to-jsx';

export type MinimalMarkdownProps = {
    text: string;
};

const Unwrap = ({ children }: { children?: React.ReactNode }) => <>{children}</>;

// Every tag markdown-to-jsx would otherwise render for unsupported syntax (headings, links,
// images, code, tables, ...) needs its own override here, or it renders normally.
const overrides = {
    ul: { props: { className: 'list-disc pl-5' } },
    h1: Unwrap,
    h2: Unwrap,
    h3: Unwrap,
    h4: Unwrap,
    h5: Unwrap,
    h6: Unwrap,
    a: Unwrap,
    img: () => null,
    code: Unwrap,
    pre: Unwrap,
    blockquote: Unwrap,
    table: Unwrap,
    hr: () => null,
};

const MinimalMarkdown = ({ text }: MinimalMarkdownProps) => {
    if (!text) return null;

    // A single "\n" is a soft break (renders as a space) unless it's a CommonMark hard break
    // (two trailing spaces before the newline), so that syntax is forced in here.
    const withHardBreaks = text.replace(/\n/g, '  \n');

    // wrapperProps is typed as IntrinsicAttributes (no className), though a plain 'div' wrapper
    // accepts one fine at runtime - hence the cast.
    const wrapperProps = { className: 'space-y-2' } as React.JSX.IntrinsicAttributes;

    return <Markdown options={{ overrides, wrapper: 'div', wrapperProps, disableParsingRawHTML: true }}>{withHardBreaks}</Markdown>;
};

export default MinimalMarkdown;
